import { createFileRoute } from '@tanstack/react-router';
import { CopyableId } from '@fiado/react-kit';

export const Route = createFileRoute('/_authenticated/_layout/tenant/roles/$roleId')({
    component: RoleDetail,
});

function RoleDetail() {
    const { roleId } = Route.useParams();
    // DEC-013: el roleId es info operativa, no un título legible. Mientras no haya un fetch del rol que
    // devuelva su displayName (pendiente Fase 1.B.WEB), lo exponemos con CopyableId (acortado + copiable)
    // en vez de pintar el UUID crudo como encabezado.
    return (
        <div className="space-y-4">
            <h1 className="text-2xl font-semibold">Rol</h1>
            <CopyableId label="ID del rol" value={roleId} />
            <p className="text-muted-foreground">
                Editar — pendiente Fase 1.B.WEB cuando RoleEditForm exista.
            </p>
        </div>
    );
}
